import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Breadcrumb, Typography, Spin } from 'antd';
import { backButton, formItemLayout, tailFormItemLayout, unexpectedError } from '../../../common_functions';

const DminSampleArea = props => {
  const { section, id } = useParams();
  const [dminArea, setDminArea] = useState({});
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        if (id !== 'new') {
          const { data } = await props.getItem('dmin_sample_area', id);
          setDminArea(data);
          formRef.current.setFieldsValue(data);
        }
      } catch (error) {
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [section, id]);

  let onFinish = async values => {
    setLoading(true);
    let newState = {
      ...dminArea,
      ...values,
    };
    try {
      let { data } = await props.saveItem('dmin_sample_area', newState);
      if (data) {
        notification['success']({
          message: 'Dmin sample area saved successfully!',
          duration: 2,
        });
        backButton(props, `/settings/dmin-sample`);
      }
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };

  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/dmin-sample" }, { title: "Dmin Sample Area", href: "/settings/dmin-sample" }, { title: id !== 'new' ? `Edit Dmin Sample Area` : 'Add Dmin Sample Area' }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {id !== 'new' ? `Edit Dmin Sample Area: ${id}` : 'Add Dmin Sample Area'}
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="artist">
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="dmin_sample_area"
                    label="Dmin Sample Area"
                    rules={[
                      {
                        required: false,
                        message: 'Dmin Sample Area is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Dmin Sample Area" />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={() => backButton(props, '/settings/dmin-sample')}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton(props.roleType, props.tabs_permissions.settings_dmin_sample, !!dminArea ? dminArea.id : '')}
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default DminSampleArea;
